<div class="create-account-pj">
  @if (saving()) {
    <div class="create-account-pj__loading">
      <div class="create-account-pj__loading-card">
        <aprova-loading-bar title="Criando sua conta..." />
      </div>
    </div>
  } @else if (!accountCreated()) {
    <div class="create-account-pj__content">
      <h1 class="create-account-pj__title">Criação de conta PJ</h1>

      <aprova-stepper
        type="bullets"
        [steps]="steps"
        [currentStep]="currentStep"
        [showStepLabels]="true"
        [allowDirectNavigation]="false"
        (stepChange)="onStepChange($event)"
      />

      @switch (currentStep) {
        @case (0) {
          <app-company-form
            [cityConnection]="cityConnection"
            [cityId]="cityEntity?.index"
            (setStepValidation)="setStepValidation(0, $event)"
          />
        }
        @case (1) {
          <app-address-form
            [hideRecaptcha]="true"
            [isLastStep]="false"
            (setStepValidation)="setStepValidation(1, $event)"
          />
        }
        @case (2) {
          <app-representative-form
            (setStepValidation)="setStepValidation(2, $event)"
          />
        }
        @case (3) {
          <app-rf-validation
            (setStepValidation)="setStepValidation(3, $event)"
            (requestBackToReview)="onRfBackToReview()"
            (introStateChange)="inRfIntroState.set($event)"
          />
        }
        @case (4) {
          <app-pj-password-form
            [hideRecaptcha]="hideRecaptcha"
            (setStepValidation)="setStepValidation(4, $event)"
            (changeRecaptcha)="onChangeRecaptcha($event)"
          />
        }
      }

      @if (!(currentStep === 3 && inRfIntroState())) {
        <div class="create-account-pj__actions">
          <button
            type="button"
            class="create-account-pj__btn create-account-pj__btn--secondary"
            (click)="goBack()"
          >
            Voltar
          </button>
          <button
            type="button"
            class="create-account-pj__btn create-account-pj__btn--primary"
            [disabled]="!isCurrentStepValid || stepping()"
            (click)="goToNextStep()"
          >
            @if (stepping()) {
              Carregando...
            } @else {
              {{ currentStep === steps.length - 1 ? 'Finalizar' : 'Continuar' }}
            }
          </button>
        </div>
      }
    </div>
  } @else {
    <div class="create-account-pj__success">
      <div class="create-account-pj__success__icon">
        <aprova-icon name="check-circle-solid" size="lg" color="currentColor" />
      </div>
      <div class="create-account-pj__success__content">
        <p class="create-account-pj__success__title">Conta criada com sucesso!</p>
        <p class="create-account-pj__success__subtitle">
          Enviamos um link de confirmação para o seu e-mail.<br>
          Acesse sua caixa de entrada e confirme a conta para liberar o acesso à Aprova.
        </p>
        <aprova-button
          buttonType="button"
          buttonClass="app-create-account__success__login__btn"
          label="Ir para o login"
          (click)="redirectToLogin()"
        />
      </div>
    </div>
  }
</div>
